import { Component, OnDestroy, OnInit } from '@angular/core';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { FuseUtilsService } from '@fuse/services/utils';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DealerDataService } from '../../dealer-data.service';

@Component({
  selector: 'ade-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class AdeHomeComponent implements OnInit, OnDestroy {
  home: any;
  isScreenSmall = false;
  isLoading = true;
  readonly isDev = !environment.production;

  private readonly _supportedWidgets = new Set<string>([
    'article.article-group',
    'article.articles-group',
    'article.block-author',
    'product.product-group',
    'widgets.banner',
    'widgets.image',
    'widgets.text',
    'widgets.block-title',
    'widgets.block-title-description',
    'widgets.editor-text',
    'widgets.gallery',
    'widgets.video',
    'widgets.form',
    'widgets.section-image-title-text',
    'widgets.spacer',
    'widgets.pai-media',
    'widgets.embed-code',
    'club.header-club',
    'microsites.display-products',
  ]);

  private _unsub = new Subject<void>();

  constructor(
    private _dataService: DealerDataService,
    private _utilService: FuseUtilsService,
    private _mediaWatcher: FuseMediaWatcherService,
  ) {}

  ngOnInit(): void {
    this._dataService
      .getHomepage()
      .pipe(takeUntil(this._unsub))
      .subscribe((res: any) => {
        const item = Array.isArray(res?.data) ? res.data[0] : res?.data;
        this.home = item ? { data: item } : null;
        this.isLoading = false;
      });

    this._mediaWatcher.onMediaChange$
      .pipe(takeUntil(this._unsub))
      .subscribe(({ matchingAliases }) => {
        this.isScreenSmall = !matchingAliases.includes('md');
      });
  }

  ngOnDestroy(): void {
    this._unsub.next();
    this._unsub.complete();
  }

  getResponsiveClasses(widget: any): string {
    if (!widget?.Columns || this.isScreenSmall) {
      return 'w-full col-span-1 md:col-span-12';
    }
    const colClasses = this._utilService.generateResponsiveClass(
      widget.Columns,
    );
    return `${widget.__component.replace('.', '_')} ${colClasses}`;
  }

  isKnownWidget(widget: any): boolean {
    return this._supportedWidgets.has(widget?.__component);
  }
}
